import { GridColDefVNW } from 'vnetwork-ui/dist/components/DataGridPro'
import { Chip, Typogaphy } from 'vnetwork-ui'
import { ContactSource } from '../../types/response'
import dayjs from 'dayjs'
import ExternalLink from '@/components/ExternalLink'
import {
    ContactStatusTypes,
    getContactStatusTypesColor,
    Industries,
} from '../../types/utils'
import i18n from '@/configs/i18n'

export const contactHRSourceColumns: GridColDefVNW<ContactSource>[] = [
    {
        field: 'contact_source_name',
        headerName: 'contact-source-name',
        width: 200,
        renderCell: ({ row }) => (
            <Typogaphy size="small">{row?.contact_source_name}</Typogaphy>
        ),
    },
    {
        field: 'contact_source_position',
        headerName: 'position',
        width: 200,
        renderCell: ({ row }) => (
            <Typogaphy size="small">{row?.contact_source_position}</Typogaphy>
        ),
    },
    {
        field: 'contact_source_phone',
        headerName: 'contact-source-phone',
        width: 150,
        renderCell: ({ row }) => (
            <Typogaphy size="small">{row?.contact_source_phone}</Typogaphy>
        ),
    },
    {
        field: 'contact_source_email',
        headerName: 'email',
        width: 150,
        renderCell: ({ row }) => (
            <Typogaphy size="small">{row?.contact_source_email}</Typogaphy>
        ),
    },
    {
        field: 'contact_source_profile',
        headerName: 'contact-source-profile',
        width: 250,
        renderCell: ({ row }) => {
            const value = row?.contact_source_profile
            return value?.match(/(http|www)/) ? (
                <a
                    href={value}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                        textDecoration: 'underline',
                        color: '#1e40af',
                    }}
                >
                    {value}
                </a>
            ) : (
                <Typogaphy size="small">{value}</Typogaphy>
            )
        },
    },

    {
        field: 'contact_source_company',
        headerName: 'company',
        width: 200,
        renderCell: ({ row }) => (
            <Typogaphy size="small">{row?.contact_source_company}</Typogaphy>
        ),
    },
    {
        field: 'contact_source_industry',
        headerName: 'contact-source-industry',
        width: 200,
        renderCell: ({ row }) => {
            const industries = Industries.find(
                (industries) =>
                    industries.value === row?.contact_source_industry
            )

            return (
                <Typogaphy size="small" className="block">
                    {industries?.label}
                </Typogaphy>
            )
        },
    },
    {
        field: 'contact_source_website',
        headerName: 'Website',
        width: 200,
        renderCell: ({ row }) =>
            row?.contact_source_website ? (
                <ExternalLink link={row.contact_source_website}>
                    {row.contact_source_website}
                </ExternalLink>
            ) : (
                <Typogaphy size="small" color="textSecondary"></Typogaphy>
            ),
    },
    {
        field: 'contact_source_notes',
        headerName: 'note',
        width: 300,
        renderCell: ({ row }) => (
            <Typogaphy size="small">{row?.contact_source_notes}</Typogaphy>
        ),
    },
    {
        field: 'contact_source_channel',
        headerName: 'contact-source-channel',
        width: 200,
        renderCell: ({ row }) => {
            return (
                <Chip
                    label={row?.contact_source_channel}
                    size="small"
                    variant="contained"
                    color={'info'}
                />
            )
        },
    },
    {
        field: 'contact_source_interested_services',
        headerName: 'contact-source-interested-services',
        width: 300,
        renderCell: ({ row }) => {
            const value = row?.contact_source_interested_services
                ?.map((service) => service)
                .join(', ')

            return (
                <Typogaphy size="small" className="block">
                    {value}
                </Typogaphy>
            )
        },
    },
    {
        field: 'contact_source_status',
        headerName: 'contact-source-status',
        width: 200,
        renderCell: ({ row }) => {
            if (row?.contact_source_status === 'HR') {
                return (
                    <Chip
                        label="HR"
                        size="small"
                        variant="contained"
                        color="info"
                    />
                )
            }
            const status = ContactStatusTypes(i18n.t).find(
                (contactStatus) =>
                    contactStatus.value === row?.contact_source_status
            )
            return (
                <Chip
                    label={status?.label}
                    size="small"
                    variant="contained"
                    color={getContactStatusTypesColor(
                        row?.contact_source_status || ''
                    )}
                />
            )
        },
    },
    {
        field: 'contact_source_created_at',
        headerName: 'created-at',
        width: 200,
        renderCell: ({ row }) => (
            <Typogaphy size="small">
                {row?.contact_source_created_at
                    ? dayjs(row.contact_source_created_at).format(
                          'DD/MM/YYYY HH:mm'
                      )
                    : ''}
            </Typogaphy>
        ),
    },
]
